export default __webpack_public_path__ + "static/media/united-tractors.fc6e949e.svg";